import { render, staticRenderFns } from "./StockistCards.vue?vue&type=template&id=78d196ba&"
import script from "./StockistCards.vue?vue&type=script&lang=js&"
export * from "./StockistCards.vue?vue&type=script&lang=js&"
import style0 from "./StockistCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports